import store from "../store";
/**
 * @description 获取设备型号
 * @returns molib 移动端 ; pc 电脑端
 */
const acquisitionDevice = () => {
  const isMobileDevice =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  if (isMobileDevice) {
    return "mobile";
  } else {
    return "pc";
  }
};

const isGroup = () => {
  const group = store.state.userInfo.groupsObj;
  if(group&&group.groupId){
    return false;
  }  return true;
  
}
export default {
  acquisitionDevice,
  isGroup
};
